<template>
  <div class="animated fadeIn text-center">
    <b-row v-if="_show_toogle_button != false">
      <b-col v-if="is_hide_check()">
        <span>
          아래 차트는 최근 1개월 동안 요청 패킷의 IP 를 기반으로 국가를 표시합니다
          <strong>GEO IP 변환 기능이 활성화 상태일 경우 사용 가능합니다</strong>

          <span class="text-info" v-b-tooltip.hover :title="tooltip" >
            <i class="fas fa-question-circle"></i>
          </span>
        </span>

      </b-col>
      <b-col :sm="is_hide_check() ? 1 : 8" v-if="is_hide_check()">
        <b-form-checkbox
          v-on:change="update_toggle($event)"
          :checked="use_geoip_custom"
          :disabled="false"
          name="check-button"
          switch
        ></b-form-checkbox>
      </b-col>
      <b-col :sm="is_hide_check() ? 2 : 4" class="text-left" v-if="is_hide_check()">
        <span v-if="use_geoip_custom">
          GEO IP 변환을 사용합니다
        </span>
        <span v-else>
          GEO IP 변환을 사용하지 않습니다
        </span>
      </b-col>
    </b-row>
    <hr v-if="is_hide_check() && _show_toogle_button != false">
    <b-row v-if="is_hide_check()">
      <b-col>
        <span class="flag-icon" :class="flags(item.policy)"></span>
        <vSelect style="margin:6px 2px; width:80%; display:inline-block" :reduce="country => country.alpha2"  v-model="item.policy" label="alpha2" :options="country" placeholder="* 지도에서 클릭 또는 선택하세요">
          <template #option="{ alpha2, name }">
            <h6 style="margin: 0">{{ alpha2 }} : {{ name }}</h6>
          </template>
        </vSelect>
        <!-- 정책 -->
        <!-- <b-input @keyup.enter="append" :maxlength="2" :state="Boolean(item.policy)" style="width: 100%;" type="text" placeholder="* 국가를 선택하세요" v-model="item.policy"></b-input> -->
      </b-col>
      <b-col>
        <!-- 모드 -->
        <b-dropdown :disabled="only_select_custom" style="width: 100%;height: 50px;border: 1px solid gray; border-radius: 12px; " :text="codes.WAF_MODE_I18N(item.mode, 'KO')" size="sm" :variant="codes.WAF_MODE_TO_COLOR(item.mode, 'variant')">
        <!-- <b-dropdown :disabled="only_select_custom" style="width: 100%;height: 50px;border: 1px solid gray; border-radius: 12px; " :text="codes.WAF_SEVERITYS_EASY_TO_DESC(item.severity, 'EN')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(item.severity, 'variant')"> -->
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => { item.mode_origin = !item.mode_origin ? codes.WAF_MODE_I18N(item.mode, 'EN') : item.mode_origin;  item.is_change = codes.WAF_MODE_I18N(item.mode_origin, 'EN') != x; item.mode = x; }"
            v-for="(x, index) in codes.WAF_MODE"
            :key="'_mode'+index"
          >{{codes.WAF_MODE_I18N(x, 'KO')}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col>
        <!-- 위험도 -->
        <b-dropdown :disabled="only_select_custom" style="width: 100%;height: 50px;border: 1px solid gray; border-radius: 12px; " :text="codes.WAF_SEVERITYS_EASY_TO_DESC(item.severity, 'KO')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(item.severity, 'variant')">
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => { item.severity_origin = !item.severity_origin ? item.severity : item.severity_origin;  item.is_change = item.severity_origin != x; item.severity = x; }"
            v-for="(x, index) in codes.WAF_SEVERITYS_EASY"
            :key="'_mode'+index"
          >{{codes.WAF_SEVERITYS_EASY_TO_DESC(x, 'KO')}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col>
        <b-button :disabled="!item.policy" size="sm" class="bton btn-addition" @click="append" style="height: 50px">
          정책 추가
        </b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col v-if="is_hide_check()">
        <div :id="gchart_id"></div>
        <span style="position:absolute; bottom:12px; left:0; width:100%; text-align:right; padding-right:60px; font-weight:bold;">
          미확인 : {{unknown_count}}
          <span class="text-info" v-b-tooltip.hover title="GEO IP 변환을 미사용하거나 공인 아이피가 아닌 내부 아이피(C 클래스 등)의 경우 국가 정보를 확인할 수 없습니다">
            <i class="fas fa-question-circle"></i>
          </span>
        </span>
      </b-col>
      <b-col class="border-left">
        <!-- 현재 설정 -->
        <p v-if="title" class="text-center font-weight-bold">
          {{title}}
        </p>
        <!-- 현재 설정 -->
        <b-row v-if="!policy_list_custom || !policy_list_custom.length" class="text-center">
          <b-col>
            설정된 정책이 없습니다
          </b-col>
        </b-row>
        <b-row v-else class="text-center mb-2">
          <b-col>
            <small>국가별 사용자 정책을 정의합니다</small>
          </b-col>
        </b-row>
        <b-row v-for="(p, p_index) in policy_list_custom" :key="'_p' + p_index" class="text-center" style="margin: 5px 0px;;">
          <b-col>
            <p style="margin: 5px; font-weight: bold;">
              <span class="flag-icon" :class="flags(p.policy)"></span>
              {{p.policy}}
              <!-- <span class="text-info" v-b-tooltip.hover title="" >
                <i class="fas fa-question-circle"></i>
              </span> -->
            </p>
          </b-col>
          <b-col>
            <!-- 모드 -->
            <b-dropdown :disabled="is_preview || only_select_custom" style="width: 80%;" :text="codes.WAF_MODE_I18N(p.mode, 'KO')" size="sm" :variant="codes.WAF_MODE_TO_COLOR(p.mode, 'variant')">
              <!-- 영문 기준으로 모드 설정 필요 -->
              <b-dropdown-item
                size="sm"
                @click="() => change('mode', p_index, codes.WAF_MODE_INTERFACE(x))"
                v-for="(x, sindex) in codes.WAF_MODE"
                :key="'_mode'+sindex"
              >{{codes.WAF_MODE_I18N(x, 'KO')}}</b-dropdown-item>
            </b-dropdown>
            <span v-if="p.last_mode_updated_at && !p.last_mode_updated_at.startsWith('0001')" class="text-info m-2 d-inline-block" v-b-tooltip.hover :title="`해당 정책의 모드는 ${moment(p.last_mode_updated_at).format('YYYY-MM-DD HH:mm:ss')} 에 마지막으로 업데이트 되었습니다`">
              <i class="fas fa-question-circle"></i>
            </span>
          </b-col>
          <!-- TODO : 레벨은 향후 사용 예정 -->
          <!-- <b-col>

            레벨
          </b-col> -->
          <b-col>
            <!-- 위험도는 현재 커스텀 강제 적용 -->
            <b-dropdown :disabled="is_preview || only_select_custom" style="width: 80%;" :text="codes.WAF_SEVERITYS_EASY_TO_DESC(p.severity, 'KO')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(p.severity, 'variant')">
              <!-- 영문 기준으로 모드 설정 필요 -->
              <b-dropdown-item
                size="sm"
                @click="() => change('severity', p_index, x)"
                v-for="(x, sindex) in codes.WAF_SEVERITYS_EASY"
                :key="'_mode'+sindex"
              >{{codes.WAF_SEVERITYS_EASY_TO_DESC(x, 'KO')}}</b-dropdown-item>
            </b-dropdown>
            <span v-if="p.last_serverity_updated_at && !p.last_serverity_updated_at.startsWith('0001')" class="text-info m-2 d-inline-block" v-b-tooltip.hover :title="`해당 정책의 위험도는 ${moment(p.last_serverity_updated_at).format('YYYY-MM-DD HH:mm:ss')} 에 마지막으로 업데이트 되었습니다`">
              <i class="fas fa-question-circle"></i>
            </span>
          </b-col>
          <b-col v-if="is_hide_check()">
            <b-button size="sm" class="btn btn-danger" @geo_reset="test()" @click="remove(p_index)">
              삭제
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
